import {
	PASTE_SUCCESS,
	SET_CHECKBOX,
	CUT_SUCCESS,
	COPY_SUCCESS,
	DELETE_SUCCESS,
	RESTORE_FROM_TRASH_SUCCESS,
	RESTORE_FROM_ARCHIVE_SUCCESS,
	SET_ALL_CHECKBOXES,
	UNSELECT_ALL,
	ARCHIVE_SUCCESS,
} from "../actions/types";

const initialState = {
	selectedDocuments: {
		Object: {},
		Folder: {},
		manifestItemType: "Document",
		header: false,
	},
	selectedPublicDocuments: {
		Object: {},
		Folder: {},
		manifestItemType: "Document",
		header: false,
	},
	selectedPrivateDocuments: {
		Object: {},
		Folder: {},
		manifestItemType: "Document",
		header: false,
	},
	selectedEmails: {
		Object: {},
		Folder: {},
		manifestItemType: "Email",
		header: false,
	},
	selectedNotes: {
		Object: {},
		Folder: {},
		manifestItemType: "Note",
		header: false,
	},
	selectedTrashDocuments: {
		Object: {},
		Folder: {},
		manifestItemType: "Document",
		header: false,
	},
	selectedTrashEmails: {
		Object: {},
		Folder: {},
		manifestItemType: "Email",
		header: false,
	},
	selectedTrashNotes: {
		Object: {},
		Folder: {},
		manifestItemType: "Note",
		header: false,
	},
	selectedTrashMatters: {
		Object: {},
		Folder: {},
		manifestItemType: "Matter",
		header: false,
	},
	selectedTrashClients: {
		Object: {},
		Folder: {},
		manifestItemType: "Client",
		header: false,
	},
	selectedArchiveDocuments: {
		Object: {},
		Folder: {},
		manifestItemType: "Document",
		header: false,
	},
	selectedArchiveEmails: {
		Object: {},
		Folder: {},
		manifestItemType: "Email",
		header: false,
	},
	selectedArchiveNotes: {
		Object: {},
		Folder: {},
		manifestItemType: "Note",
		header: false,
	},
	clipboard: {},
	sourceBasepath: "",
	sourceDirectoryID: null,
	cut: false,
};
const trashTableRootMap = {
	"trash/docs/": "selectedTrashDocuments",
	"trash/email/": "selectedTrashEmails",
	"trash/notes/": "selectedTrashNotes",
	"trash/matters/": "selectedTrashMatters",
	"trash/clients/": "selectedTrashClients",
};
const archiveTableRootMap = {
	"archive/docs/": "selectedArchiveDocuments",
	"archive/email/": "selectedArchiveEmails",
	"archive/notes/": "selectedArchiveNotes",
};
export const selectTableRootMap = {
	// the keys without "/" at the end are necessary for cut/copy and paste
	"docs/": "selectedDocuments",
	docs: "selectedDocuments",
	"email/": "selectedEmails",
	email: "selectedEmails",
	"notes/": "selectedNotes",
	notes: "selectedNotes",
	"public/": "selectedPublicDocuments",
	public: "selectedPublicDocuments",
	"private/": "selectedPrivateDocuments",
	private: "selectedPrivateDocuments",
	...trashTableRootMap,
	...archiveTableRootMap,
};

export const selectTableTypeMap = {
	File: "Object",
	Email: "Object",
	Note: "Object",
	Folder: "Folder",
	Matter: "Object",
	Client: "Object",
};

function determineListName(sourceBasepath) {
	if (trashTableRootMap[sourceBasepath]) {
		return trashTableRootMap[sourceBasepath];
	} else if (archiveTableRootMap[sourceBasepath]) {
		return archiveTableRootMap[sourceBasepath];
	} else {
		return selectTableRootMap[sourceBasepath.split("/")[0]];
	}
}

export default function (state = initialState, action) {
	var listName;
	switch (action.type) {
		case SET_CHECKBOX:
			// make a deep copy of the state
			// otherwise the Object/Folder object will be mutated directly in the initalState
			var newSelection = structuredClone({
				...state[action.payload.listName],
			});

			if (action.payload.checked) {
				newSelection[selectTableTypeMap[action.payload.type]][
					action.payload.id
				] = action.payload.row;
			} else {
				delete newSelection[selectTableTypeMap[action.payload.type]][
					action.payload.id
				];
			}
			return {
				...state,
				[action.payload.listName]: newSelection,
			};
		case SET_ALL_CHECKBOXES:
			var newState = {
				...state,
				[action.payload.listName]: !state[action.payload.listName]
					.header
					? {
							...initialState[action.payload.listName],
							...action.payload.config,
							header: true,
						}
					: {
							...initialState[action.payload.listName],
						},
			};
			return newState;
		case UNSELECT_ALL:
			return {
				...state,
				selectedDocuments: { ...initialState.selectedDocuments },
				selectedEmails: { ...initialState.selectedEmails },
				selectedNotes: { ...initialState.selectedNotes },
				selectedPublicDocuments: {
					...initialState.selectedPublicDocuments,
				},
				selectedPrivateDocuments: {
					...initialState.selectedPrivateDocuments,
				},
				selectedTrashDocuments: {
					...initialState.selectedTrashDocuments,
				},
				selectedTrashEmails: { ...initialState.selectedTrashEmails },
				selectedTrashNotes: { ...initialState.selectedTrashNotes },
				selectedTrashMatters: {
					...initialState.selectedTrashMatters,
				},
				selectedTrashClients: {
					...initialState.selectedTrashClients,
				},
				selectedArchiveDocuments: {
					...initialState.selectedArchiveDocuments,
				},
				selectedArchiveEmails: {
					...initialState.selectedArchiveEmails,
				},
				selectedArchiveNotes: {
					...initialState.selectedArchiveNotes,
				},
			};
		case CUT_SUCCESS:
			listName = determineListName(action.payload.sourceBasepath);
			return {
				...state,
				[listName]: { ...initialState[listName] },
				clipboard: state[listName],
				sourceBasepath: action.payload.sourceBasepath,
				sourceDirectoryID: action.payload.sourceDirectoryID,
				cut: true,
			};
		case COPY_SUCCESS:
			listName = determineListName(action.payload.sourceBasepath);
			return {
				...state,
				[listName]: { ...initialState[listName] },
				clipboard: state[listName],
				sourceBasepath: action.payload.sourceBasepath,
				sourceDirectoryID: action.payload.sourceDirectoryID,
				cut: false,
			};
		case PASTE_SUCCESS:
			listName = determineListName(action.payload.sourceBasepath);
			var mixinIfCameFromCut = state.cut
				? { clipboard: {}, sourceBasepath: "", sourceDirectoryID: null }
				: {};
			return {
				...state,
				...mixinIfCameFromCut,
				[listName]: { ...initialState[listName] },
			};
		case DELETE_SUCCESS:
		case ARCHIVE_SUCCESS:
			listName = determineListName(action.payload.sourceBasepath);
			return {
				...state,
				[listName]: { ...initialState[listName] },
			};
		case RESTORE_FROM_TRASH_SUCCESS:
		case RESTORE_FROM_ARCHIVE_SUCCESS:
			listName = determineListName(action.payload.sourceBasepath);
			return {
				...state,
				[listName]: { ...initialState[listName] },
			};
		default:
			return state;
	}
}
